import React, { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import ThemedButton from 'components/common/ThemedButton';
import CrossIcon from 'images/close.svg';
import CheckIcon from 'images/icons/check.svg';
import DuplicateIcon from 'images/icons/copy.svg';
import DollarIcon from 'images/icons/dollar-sign-solid.svg';
import TrashIcon from 'images/icons/icon-trash.svg';
import EditIcon from 'images/icons/icon-edit.svg';
import DescriptionIcon from 'images/icons/icn-description.svg';
import downloadFile from 'utils/downloadUtils';
import useOrders from '../useOrders';
import './OrderActions.scss';
const OrderActions = ({ order, ordersUrl, }) => {
    const { i18n: { language }, t, } = useTranslation('orders');
    const history = useHistory();
    const handlers = useOrders();
    const remove = useCallback(() => {
        handlers.removeOrder(order.id).then(() => {
            history.push(ordersUrl);
        });
    }, [handlers, order.id, history, ordersUrl]);
    const approve = useCallback(() => {
        handlers.updateOrderApprove(order.id);
    }, [handlers, order.id]);
    const cancel = useCallback(() => {
        handlers.updateOrderCancel(order.id);
    }, [handlers, order.id]);
    const complete = useCallback(() => {
        handlers.updateOrderComplete(order.id);
    }, [handlers, order.id]);
    const duplicate = useCallback(() => {
        handlers.duplicateOrder(order.id);
    }, [handlers, order.id]);
    const correction = useCallback(() => {
        handlers.createOrderCorrection(order.id).then((orderId) => {
            history.replace(`/orders/${orderId}/specifications`);
        });
    }, [handlers, history, order.id]);
    const onClickExport = useCallback(() => downloadFile(`/export/getOrderComponents/${order === null || order === void 0 ? void 0 : order.id}/${language}`), [language, order === null || order === void 0 ? void 0 : order.id]);
    const canApprove = order.sumOfModelQuantities > 0 && order.allModelsReady && order.allComponentVariantsReady;
    const approveTooltip = canApprove
        ? undefined
        : [
            t('cannot_approve'),
            ...(order.sumOfModelQuantities > 0 ? [] : [t('cannot_approve_no_models')]),
            ...(order.allModelsReady ? [] : [t('cannot_approve_models_not_ready')]),
            ...(order.allComponentVariantsReady ? [] : [t('cannot_approve_variants_not_ready')]),
        ].join('\n');
    return (React.createElement("div", { className: "OrderActions action-buttons" },
        order.status === 'DRAFT' && [
            React.createElement("span", { key: "approve", title: approveTooltip },
                React.createElement(ThemedButton, { icon: React.createElement(CheckIcon, null), className: "approveButton", onClick: approve, disabled: !canApprove }, t('approve'))),
            React.createElement(ThemedButton, { key: "remove", icon: React.createElement(TrashIcon, null), className: "removeButton", onClick: remove }, t('remove')),
        ],
        order.status !== 'DRAFT' && [
            React.createElement(ThemedButton, { key: "duplicate", icon: React.createElement(DuplicateIcon, null), className: "duplicateButton", onClick: duplicate }, t('duplicate_as_draft')),
        ],
        order.status === 'APPROVED' && [
            React.createElement(ThemedButton, { key: "cancel", icon: React.createElement(CrossIcon, null), className: "cancelButton", onClick: cancel }, t('cancel')),
            React.createElement(ThemedButton, { key: "complete", icon: React.createElement(DollarIcon, null), className: "completeButton", onClick: complete }, t('complete')),
            React.createElement(ThemedButton, { key: "correction", icon: React.createElement(EditIcon, null), className: "correctionButton", onClick: correction }, t('correction_action')),
        ],
        React.createElement(ThemedButton, { key: "export", icon: React.createElement(DescriptionIcon, null), className: "exportButton", disabled: order.models.edges.length === 0, onClick: onClickExport },
            React.createElement("span", null, t('export')))));
};
export default memo(OrderActions);
